import React, {useEffect, useState} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {useDispatch, useSelector} from "react-redux";
import {Col} from "react-bootstrap";
import FormHandler from "../../shared/util/form-handler";
import {validateDepartmentSubmit} from "../../shared/authentication/form-validation-rules";
import FeatherIcon from 'feather-icons-react';
import axios from "axios";
import {toast} from "react-toastify";
import {getUserId} from "../../shared/authentication/authentication";
import DepartmentItem from "./department-item";
import {VIEW} from "../../shared/util/enum";
import {
    changeView,
    resetConfirmationDialog,
    toggleConfirmationDialog,
    toggleLoader
} from "../../shared/actions/setting";
import { fetchDepartment } from "../../actions/department";

const DepartmentList = (props) => {
    const dispatch = useDispatch();
    const corporateID = "60a7794ef812231385f6dce0";
    const [departmentList, setDepartmentList] = useState([]);
    const [isAddDepartment, setIsAddDepartment] = useState(false);
    const [suggestionList,setSuggestionList]=useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
    const [formErr, setFormErr] = useState(null);
    const [deleteId, setDeleteId] = useState("");
    const [updateIndex,setUpdateIndex] = useState([]);
    const confirmationDialog = useSelector(state => {
        return state.setting.confirmationDialog
    });
    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        initForm,
        deleteErrors,
    } = FormHandler(department, validateDepartmentSubmit);

    useEffect(() => {
        dispatch(toggleLoader(true));
        axios.get(process.env.REACT_APP_HOST + 'user/'
            + getUserId() + '/corporate/'+ corporateID +'/department' )
            .then(res => {
                setDepartmentList(res.data.content);
                dispatch(fetchDepartment(res.data.content))
            }).catch(error => {
                if (error.response && error.response.status === 422) {
                    toast.error(error.response.data.message);
                }
            }).finally(() => {
                dispatch(toggleLoader(false))
            })

    }, [corporateID]);

    useEffect(() => {
        dispatch(changeView(VIEW.DEPT_LIST));
    }, []);

    useEffect(() => {
        if (!isLoading) {
            return;
        }
        if (!isUpdateAvailable) {
            values.corporateId = "60a7794ef812231385f6dce0";
            dispatch(toggleLoader(true));
            axios.post(process.env.REACT_APP_HOST + `user/` + getUserId() + '/department', values)
                .then(res => {
                    setIsAddDepartment(false);
                    setDepartmentList(oldArray => [...oldArray,res.data.content]);
                    toast.success("Department created successfully");
                    resetForm();
                })
                .catch(error => {
                        if (error.response && error.response.status === 422) {
                            setFormErr(error.response.data.message);
                        }
                        console.log(error);
                    }
                )
                .finally(() => {
                    setIsLoading(false);
                    dispatch(toggleLoader(false));
                });
        }
        else {
                values.corporateId = "60a7794ef812231385f6dce0";
                dispatch(toggleLoader(true));
                axios.put(process.env.REACT_APP_HOST + `user/` + getUserId() + '/department/' + values.id, delete values.index && delete values.id && values)
                    .then(res => {
                        setIsAddDepartment(false);
                        departmentList[updateIndex] = res.data.content;
                        setDepartmentList(departmentList);
                        toast.success("Department updated successfully");
                        resetForm();
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 422) {
                            setFormErr(error.response.data.message);
                        }
                    })
                    .finally(() => {
                        setIsLoading(false);
                        dispatch(toggleLoader(false));
                    });
            }
    }, [isLoading]);

    useEffect(() => {
        if (!confirmationDialog || !confirmationDialog.onSuccess) {
            return;
        }
        console.log(deleteId)
            dispatch(resetConfirmationDialog());
            dispatch(toggleLoader(true));
            axios.delete(process.env.REACT_APP_HOST + `user/` + getUserId() + '/department/' + deleteId)
                .then(res => {
                    setDepartmentList(departmentList.filter(item => item.id !== deleteId));
                    toast.success("Department deleted successfully");
                    dispatch(toggleLoader(false));
                }).catch(error => {
                dispatch(toggleLoader(false));
                if (error.response && error.response.status === 422) {
                    toast.warn(error.response.data.message);
                }
            })
    }, [confirmationDialog]);

    function department() {
        setIsLoading(true);
    }

    function resetForm() {
        initForm({});
        deleteErrors(errors);
        setIsUpdateAvailable(false);
        // setStartDate(new Date());
        setFormErr("");
    }

    function formClick(event) {
        let names=['suggestion','name'];
        if(!event.target.name || !names.includes(event.target.name ) ){
            suggestionList.length >0 && setSuggestionList([]);
        }
    }

    function handleDeleteDepartment(id) {
        dispatch(toggleConfirmationDialog({
            isVisible: true,
            confirmationHeading: "Are you sure you want to delete this department?"
            ,
            confirmationDescription: "The delete action will remove the department."
        }));
        setDeleteId(id);
    }

    function setIsUpdateAvailableEdit(id,index,name) {
        values.id = id;
        values.name = name;
        setIsUpdateAvailable(true);
        setIsAddDepartment(true);
        setUpdateIndex(index);
        console.log(index)
    }

    return (
        <div>
            <div id="listView" className={'list-view full-list-view'}>
                <div className={"half-list-container spy-half-list-m"}>
                    <Container className="m-t-8">
                        <Row id={"m-rl-m-16"}>
                            {departmentList.length > 0 && departmentList.sort(function(a,b){
                            }) && departmentList.map((departmentProp, index) =>
                            <Col xl={3} lg={6} key={index}>
                                <DepartmentItem department={departmentProp} index={index}  parentCallback = {handleDeleteDepartment} parentCallbackEdit = {setIsUpdateAvailableEdit}/>
                            </Col>
                            )}
                            {departmentList.length === 0 && (
                                <div className={"empty-results"}>
                                    <FeatherIcon icon="info"/>
                                    <div className={"empty-results-text"}>There are no departments</div>
                                </div>
                            )}
                        </Row>
                    </Container>
                </div>
            </div>
            <div>
                <div>
                    <div className="map-toggle-add-btn ">
                        <div className="container" >
                            <div className="pull-right toggle-btn" >
                                <div className="">
                                    <div className="add-btn sa-cursor">
                                        <FeatherIcon
                                            onClick={() => {
                                                resetForm()
                                                setIsAddDepartment(true);
                                            }}
                                            className={"icon-in-add-btn"} icon="plus-circle"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                {/* -----------------------------------------------------------------Add Department--------------------------------------------------- */}
                {isAddDepartment && <div  onClick={formClick} className="sa-modal-bg">
                    <div className="sa-modal-bg-inner">
                        <div className="sa-modal-box department-add-edit">
                            <div className="container">
                                <form onSubmit={handleSubmit} noValidate>
                                    <div className="sa-modal-header">
                                        {!isUpdateAvailable ? "Add New Department" : "Edit Department"}
                                        <div className="sa-modal-close" onClick={() => {setIsAddDepartment(false)}}>
                                            <FeatherIcon className={"icon-in-close"} icon={"x"}/>
                                        </div>
                                    </div>
                                    <div className="row sa-modal-content">
                                        <div className="col-md-6">
                                            <div className="form-group m-b-16">
                                                <label>Department Name</label>
                                                <input type="text"
                                                    className={`form-control ${errors.name && "warning-input"}`}
                                                    name="name"
                                                    onChange={handleChange}
                                                    value={values.name || ""}
                                                    autoComplete={"off"}
                                                    placeholder="Enter Department Name"
                                                />
                                            </div>
                                            {errors.name && (<p className="warning-input-msg">{errors.name}</p>)}
                                        </div>
                                    </div>
                                    {formErr && (<div id={"formErr"} className={"login-warning-msg"}>{formErr}</div>)}
                                    <div className="sa-modal-footer">
                                        <div className="sa-modal-footer-btn">
                                            <button id="btnCancel" type={"button"} className="btn btn-sa-text btn-sa-text-size btn-sa-width" onClick={() => {
                                                setIsAddDepartment(false);
                                            }}>
                                                CANCEL
                                            </button>
                                            <button id="btnAdd" className="btn btn-sa-primary-factoryspy btn-sa-width">
                                                {!isUpdateAvailable ? "ADD" : "UPDATE"}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
  )
};

export default DepartmentList;
